const MapCenter = props => <span className={ props.classNames } role="img" aria-label="Map center">⨁</span>;

export default MapCenter;
